/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_History_WordsInputs */

const en_us2_search_history_words = /** @type {(inputs: Search_History_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`history session workouts done`)
};

const pt_br2_search_history_words = /** @type {(inputs: Search_History_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`historico sessao treinos feitos`)
};

const es_419_search_history_words = /** @type {(inputs: Search_History_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`historial sesion entrenamientos hechos`)
};

const pt_pt2_search_history_words = /** @type {(inputs: Search_History_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`historico sessao treinos feitos`)
};

const fr_fr2_search_history_words = /** @type {(inputs: Search_History_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`historique seance seances faites`)
};

const de_de2_search_history_words = /** @type {(inputs: Search_History_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`verlauf einheit trainings erledigt`)
};

const it_it2_search_history_words = /** @type {(inputs: Search_History_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`storico sessione allenamenti fatti`)
};

/**
* | output |
* | --- |
* | "history session workouts done" |
*
* @param {Search_History_WordsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_history_words = /** @type {((inputs?: Search_History_WordsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_History_WordsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_history_words(inputs)
	if (locale === "es-419") return es_419_search_history_words(inputs)
	if (locale === "pt-PT") return pt_pt2_search_history_words(inputs)
	if (locale === "fr-FR") return fr_fr2_search_history_words(inputs)
	if (locale === "de-DE") return de_de2_search_history_words(inputs)
	if (locale === "it-IT") return it_it2_search_history_words(inputs)
	return en_us2_search_history_words(inputs)
});
export { search_history_words as "search.history_words" }